import { ButtonProps } from '@chakra-ui/react'

import ButtonContext from './button-context'

const Button = (props: ButtonProps & { href?: string }) => (
  <ButtonContext.Consumer>{(Value) => <Value {...props} />}</ButtonContext.Consumer>
)
export default Button
